/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MermaidDiagram({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#MermaidDiagram_svg__a)"><path fill="currentColor" d="M7.67.999a.6.6 0 0 1 .754.077l3 3a.6.6 0 0 1 0 .848L8.94 7.406 12.682 9.9h1.568c.745 0 1.35.604 1.35 1.35v2.5a1.35 1.35 0 0 1-1.35 1.35h-3.5a1.35 1.35 0 0 1-1.35-1.35v-2.5c0-.675.496-1.234 1.144-1.333L8 8.22 5.455 9.917A1.35 1.35 0 0 1 6.6 11.25v2.5a1.35 1.35 0 0 1-1.35 1.35h-3.5A1.35 1.35 0 0 1 .4 13.75v-2.5c0-.746.604-1.35 1.35-1.35h1.567L7.06 7.406 4.576 4.924a.6.6 0 0 1 0-.848l3-3zm-5.92 10.1a.15.15 0 0 0-.15.151v2.5c0 .083.067.15.15.15h3.5a.15.15 0 0 0 .15-.15v-2.5a.15.15 0 0 0-.15-.15zm9 0a.15.15 0 0 0-.15.151v2.5c0 .083.067.15.15.15h3.5a.15.15 0 0 0 .15-.15v-2.5a.15.15 0 0 0-.15-.15zM5.848 4.5 8 6.653 10.152 4.5 8 2.348z" /></g><defs><clipPath id="MermaidDiagram_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;